import { Text, Skeleton } from "@chakra-ui/react";
import { Flex } from "@chakra-ui/layout";
import colors from "core/resources/theme/colors";
import { FaBuilding } from "react-icons/fa";

interface CardResultadosProps {
  name: string;
  complete: boolean;
  description?: string;
  icon?: any;
  bg?: string;
  value: number | string;
  isLoading?: boolean;
}

function CardResultados({
  name,
  description,
  complete,
  icon,
  bg,
  value,
  isLoading,
}: CardResultadosProps) {
  if (isLoading) {
    return <Skeleton h="110px" w="330px" mb="5" mr="5" rounded="16px" />;
  }
  return (
    <Flex
      mb="5"
      mr="5"
      h="110px"
      w="330px"
      justifyContent="center"
      alignItems="center"
      boxShadow="0 0 24px rgba(0,0,0,.05)"
      flexDir="column"
      bg="white"
      rounded="16px"
      py="20px"
      px="10px"
      cursor="pointer"
    >
      <Flex>
        <Flex
          w="50px"
          h="50px"
          rounded="50%"
          justifyContent="center"
          alignItems="center"
          bg={bg ? bg : complete ? colors.green100 : colors.orange100}
        >
          {!icon ? (
            <FaBuilding
              fontSize="18px"
              color={complete ? colors.green : colors.orange}
            />
          ) : (
            icon
          )}
        </Flex>
        <Flex
          fontWeight="bold"
          fontSize={28}
          ml="4"
          alignItems="center"
          color={colors.black900}
        >
          {value}
        </Flex>
      </Flex>
      <Text
        mt="8px"
        fontSize="12px"
        fontWeight="bold"
        textAlign="center"
        w="100%"
      >
        {name}
      </Text>
      {description ? (
        <Text
          mt="16px"
          fontSize="12px"
          fontWeight="bold"
          textAlign="center"
          noOfLines={1}
        >
          {description}
        </Text>
      ) : null}
    </Flex>
  );
}

export default CardResultados;
